import React, { useEffect, useState } from "react";
import { remittanceFormData } from "../../forms/RemittanceForm";
import IconEditHover from "../../assets/svg/pen-icon-account.svg";
import "../../assets/styles/productServices/addProduct.scss";
import "../../assets/styles/factor/factor.scss";
import TableAdd from "../simple/TableAdd";
import buyerSellerIcon from "../../assets/svg/buyer-seller-icon.svg";
import LoginIconGreen from "../../assets/svg/login-icon-green.svg";
import bookMarkFactorWhite from "../../assets/svg/bookMarkFactorWhite.svg";
import { RenderFactorInputs } from "../Input/render";
import { useDispatch, useSelector } from "react-redux";
import { apiGetRemittance, apiSaveRemittance, apiUpdateRemittance } from "../../api/remittanceApi";
import imgAddFator from "../../assets/svg/icon-add-factor.svg";
import { FormTypeSelectionInput, SelectBox } from "../Input";
import { formatDate, formatPrice, setSelectItemLabels } from "../../helpers";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { resetRemittance, setEditItem, updateRemittance } from "../../store/actions/formAction";
import { apiFactorsList, apiGetFactor } from "../../api/factorApi";
import addProductTransaction from "../../assets/svg/addProductTransaction.svg";
import { PageHeader } from "../Form/components";
import getCurrency from "helpers/currencyHelper";
import { store } from "store/store";
import { apiProductsList } from "api/productApi";
import { apiGetWarehouses } from "api/warehouseApi";
import { apiGetProjects } from "api/projectApi";
import { apiGetBranches } from "api/branchApi";
import { apiGetPersons } from "api/personApi";

export const RemittanceForm = (props) => {
  const { id } = useParams();
  const { hideTabs, displayHeader = false } = props;
  const dispatch = useDispatch();
  const { getState } = store
  const location = useLocation();
  const remittanceForm = remittanceFormData.remittance;
  const remittance = useSelector((state) => state).formReducer.remittance;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const token = useSelector((state) => state).businessReducer.business?.token;
  const [activeTab, setActiveTab] = useState(remittanceForm.tabs[0].key);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    title: "سند",
    tabs: remittanceForm.tabs,
  });

  useEffect(() => {
    const allProducts = getState().productReducer.allProducts
    const branches = getState().branchReducer.branches
    const projects = getState().projectReducer.projects
    const warehouses = getState().warehouseReducer.warehouses
    const customers = getState().personReducer.customers
    if (!allProducts.length) {
      dispatch(apiProductsList(token))
    }
    if (!branches.length) {
      dispatch(apiGetBranches(token))
    }
    if (!projects.length) {
      dispatch(apiGetProjects(token))
    }
    if (!warehouses.length) {
      dispatch(apiGetWarehouses())
    }
    if (!customers.length) {
      dispatch(apiGetPersons({token,key:"customer"}))
    }
    if (id) {
      dispatch(apiGetRemittance(id, token));
    } else {
      dispatch(resetRemittance());
      dispatch(setEditItem(null));
      dispatch(apiFactorsList(token, form.tabs[0].factorTypes, "bill"));
      setActiveTab(form.tabs[0].key);
      // updateRemittanceObejct(false)
    }

    if (location.state?.type) {
      setActiveTab(location.state?.type);
    }
  }, []);

  // useEffect(() => {
  //     updateRemittanceObejct(true)
  // }, [editItem]);

  useEffect(() => {
    dispatch(updateRemittance("type", activeTab));

    const tabs = hideTabs ? remittanceForm.tabs.filter((tab) => tab.key === activeTab) : remittanceForm.tabs;

    setForm({
      title: "سند",
      tabs: tabs,
    });
  }, [activeTab]);

  useEffect(() => {
    if (remittance.remittanceFactor && remittance.remittanceFactor.id) {
      dispatch(
        apiGetFactor(remittance.remittanceFactor.id, remittance.remittanceFactor.type, token, (factor) =>
          dispatchFactorActions(factor)
        )
      );
    } else {
      dispatch(updateRemittance("factor", null));
    }
  }, [remittance.remittanceFactor]);

  // const updateRemittanceObejct = (isEdit) => {
  //     const remittanceObject = isEdit ? editItem : remittance
  //     if (remittanceObject) {
  //         if (remittanceObject.from) {
  //             setOriginActiveTab(transferObject.from.type ?? originActiveTab)
  //         }
  //     }
  // }

  const dispatchFactorActions = (factor) => {
    const remittanceType = getRemittanceType(factor.type);
    setLoading(true);
    setActiveTab(remittanceType);
    // const date = formatDate(factor.dueDate, true, true);
    const project = setSelectItemLabels(factor.Project, "id", "title");
    const remittanceDescription = `حواله ${remittanceType === "enter" ? "ورود" : "خروج"} فاکتور شماره #${factor.accountingCode
      }`;
    const items = [];
    const factorItems = editItem && editItem.Product_Bills ? editItem.Product_Bills : factor.Factor_Items;
    factorItems.map((i, index) => {
      const unit = i.unit === i.Product.subUnit ? "secondary" : "main";
      i.index = index;
      i.unit = unit;
      i.product = setSelectItemLabels(i.Product, "id", "title");
      items.push(i);
    });

    dispatch(updateRemittance("factor", factor));
    dispatch(updateRemittance("Project", project));
    dispatch(updateRemittance("description", remittanceDescription));
    // dispatch(updateRemittance("date", date));
    dispatch(updateRemittance("items", items));

    setTimeout(() => {
      setLoading(false);
    }, 50);
  };

  const getRemittanceType = (type) => {
    if (type === "buy" || type === "saleReturn") {
      return "enter";
    }
    return "exit";
  };

  const changeActiveTab = (tabToActive) => {
    const tab = form.tabs.find((t) => t.key === tabToActive);

    if (tab && tabToActive !== activeTab) {
      setActiveTab(tabToActive);
      setLoading(true);
      if (tab.factorTypes) {
        dispatch(apiFactorsList(token, tab.factorTypes, "bill"));
      }

      if (!editItem) {
        dispatch(updateRemittance("factor", null));
        dispatch(updateRemittance("Project", null));
        dispatch(updateRemittance("description", null));
        dispatch(updateRemittance("date", null));
        dispatch(updateRemittance("items", []));
      }
      setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  };

  const titleTableAddFactor = {
    formType: "remittance",
    outerWrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    type: "factorTable",
    name: "items",
    inputs: [
      { key: "product", title: "کالا", size: "240", type: "select" },
      { key: "unit", title: "واحد", size: "131", type: "unit" },
      { key: "quantity", title: "مقدار", size: "87", type: "price" },
      { key: "description", title: "توضیحات", size: "400", type: "text" },
    ],
  };

  return loading ? null : (
    <>
      {displayHeader ? (
        <div className="wrap-add-product row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <PageHeader header={remittanceForm.navigation} activeTab={activeTab} spaceLess={true} />
          </div>
        </div>
      ) : null}
      <div className="row">
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <div className="row">
            <div className="header-factor">
              <FormTypeSelectionInput form={form} activeTab={activeTab} setActiveTab={changeActiveTab} />
            </div>
            <div className="body-top-factor">
              <div className="row">
                <RenderFactorInputs form={remittanceForm.tabs.find((r) => r.key === activeTab).inputs} />
              </div>
            </div>
            <div className="header-factor-receve">
              <div>جزییات فاکتور</div>
            </div>
            <div className="body-top-factor" style={{ overflow: "auto" }}>
              {<TableAdd input={titleTableAddFactor} />}
            </div>
          </div>
        </div>
        <RemittanceSummary activeTab={activeTab} />
      </div>
    </>
  );
};

const RemittanceSummary = ({ activeTab }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const copy = queryParams.get("copy") === "1";
  const remittance = useSelector((state) => state).formReducer.remittance;
  const sendingRequest = useSelector((state) => state).appReducer.sendingRequest;
  const token = useSelector((state) => state).businessReducer.business?.token;
  const saleFactorTypes = ["sale", "saleReturn"];

  const [addFactorInput, setAddFactorInput] = useState(true);
  const [addFactor, setAddFactor] = useState(true);

  useEffect(() => {
    if (remittance.factor) {
      setAddFactorInput(false);
      setAddFactor(false);
    } else {
      setAddFactorInput(true);
      setAddFactor(true);
    }
  }, [remittance.factor]);

  const issuingAssignment = () => {
    if (id && !copy) {
      dispatch(apiUpdateRemittance(id, remittance, token, navigate));
    } else {
      dispatch(apiSaveRemittance(remittance, token, navigate));
    }
  };

  const selectFactor = {
    formType: "remittance",
    outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
    type: "selectBox",
    name: "remittanceFactor",
    label: "انتخاب فاکتور",
    showInput: true,
    options: "factors",
  };

  return (
    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
      <div className="wrap-receipt-box">
        <h6>خلاصه حواله</h6>
        {activeTab !== "transfer" ? (
          addFactorInput ? (
            <>
              <div className="box-add-factor">
                {addFactor ? (
                  <div className="body-box-add-factor" onClick={() => setAddFactor(false)}>
                    <div className="img-add-factor">
                      <img src={imgAddFator} alt="imgAddFator" />
                    </div>
                    <div className="add-factor-form-transaction">
                      {/* <img src={addFactorIconPlus} alt="addFactorIconPlus" /> */}
                      {activeTab === "enter" ? "انتخاب فاکتور خرید" : activeTab === "exit" ? "انتخاب فاکتور فروش" : "انتخاب فاکتور حواله"}                </div>
                  </div>
                ) : (
                  <div className="body-box-add-factor">
                    <img
                      className="img-add-product-tansaction"
                      src={addProductTransaction}
                      alt="addProductTransaction"
                      onClick={() => setAddFactorInput(false)}
                    />
                    <SelectBox input={selectFactor} />
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="header-receipt-box">
              <div className="box-header-top">
                <div className="text-code">{remittance.factor?.accountingCode}</div>
                <div>{remittance?.factor?.dueDate ? remittance.factor.dueDate : null}</div>
                <div className="icon-edit-receipt-box">
                  <img src={IconEditHover} alt={"IconEditHover"} onClick={() => setAddFactorInput(true)} />
                </div>
              </div>
              <div className="box-header-center">
                <div>فاکتور</div>
                <div>
                  <b>{formatPrice(remittance.factor?.totalPrice ?? 0)}</b>
                  <span> {remittance.factor?.Currency?.en_title ?? getCurrency().defCur.en_title}</span>
                </div>
              </div>
              <div className="box-header-footer">
                <img src={buyerSellerIcon} alt="buyerSellerIcon" />
                <div className="buyer-text">
                  {saleFactorTypes.includes(remittance.factor?.type) ? "مشتری" : "فروشنده"}:{" "}
                  {remittance.factor?.Person?.nickName ?? ""}
                </div>
                <div>
                  {remittance.factor?.Factor_Items?.reduce((sum, item) => {
                    return sum + +(item.quantity ?? 0);
                  }, 0) ?? 0}{" "}
                  کالا
                </div>
              </div>
            </div>
          )
        ) : null}
        <div className="content-receipt-box">
          <div className="box-body-top">
            <dv className="text-code">
              {remittance.accountingCodeType === false
                ? (remittance.accountingCode && remittance.accountingCode.length) > 0
                  ? remittance.accountingCode
                  : "دستی"
                : "اتوماتیک"}
            </dv>
            <dv>{formatDate(remittance.date)}</dv>
          </div>
          <div className="login-werehouse-factor">
            <img src={LoginIconGreen} alt="LoginIconGreen" />
            رسید {activeTab === "enter" ? "ورود به " : activeTab === "exit" ? "خروج از " : "انتقال از "} انبار
          </div>
          {activeTab === "transfer" ? (
            <>
              <div className="receipt-count">
                <b>
                  {remittance?.Warehouse?.accountingCode} - {remittance?.Warehouse?.title}
                </b>
              </div>
              <div className="login-werehouse-factor">{"انتقال به "} انبار</div>
              <div className="receipt-count">
                <b>
                  {remittance?.TargetWarehouse?.accountingCode} - {remittance?.TargetWarehouse?.title}
                </b>
              </div>
            </>
          ) : (
            <div className="receipt-count">
              <b>
                {remittance?.Warehouse?.accountingCode} - {remittance?.Warehouse?.title}
              </b>
            </div>
          )}
          <div className="item-delivery-box">
            <div>حمل و نقل</div>
            <div>{remittance.transport ?? "-"}</div>
          </div>
          <div className="item-delivery-box">
            <div>تحویل</div>
            <div>{remittance.delivery ?? "-"}</div>
          </div>
        </div>
        <div className="btns-footer-box-left-right-receipt">
          <button
            type="button"
            disabled={sendingRequest}
            className="save-and-continuation"
            onClick={() => issuingAssignment()}
          >
            <img src={bookMarkFactorWhite} alt="bookMarkFactorWhite" />
            {activeTab === "enter" ? 'صدور رسید انبار' : activeTab === "exit" ? " صدور حواله خروج" : "صدور حواله"}
          </button>
        </div>
      </div>
    </div>
  );
};
